// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wAOl","col":"styles_col__1OPCF","actions":"styles_actions__3UR_G","conflict":"styles_conflict__1qtEe"};